<template>
  <div>
    <div class="content">
      <v-app>
        <v-content>
          <v-container>
            <div class="">
              <div class="my-4 text-h4 mx-2">{{ name }} 隐私政策</div>
              <div style="padding: 10px 0 10px 25px">
                <div>
                  政策发布时间：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2024-01-01
                </div>
                <div>
                  最近更新时间：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2025-01-26
                </div>
                <div>更新版本生效时间：&nbsp;&nbsp;2025-03-10</div>
              </div>

              <div style="height: 20px"></div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                欢迎您访问我们的产品。
                <strong> {{ name }} </strong>（包括手机APP、网站、小程序等产品提供的服务，以下简称“产品和服务”）是由
                <strong> {{people_name}} </strong>（以下简称“我们”）开发并运营的。
                确保用户的数据安全和隐私保护是我们的首要任务，
                本隐私政策载明了您访问和使用我们的产品和服务时所收集的数据及其处理方式。
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                请您在继续使用我们的产品前务必认真仔细阅读并确认充分理解本隐私政策全部规则和要点，
                一旦您选择使用，即视为您同意本隐私政策的全部内容，同意我们按其收集和使用您的相关信息。
                如您在在阅读过程中，对本政策有任何疑问，可联系我们的客服咨询， 请通过
                <strong> {{ email }} </strong>或产品中的反馈方式与我们取得联系。
                如您不同意相关协议或其中的任何条款的，您应停止使用我们的产品和服务。
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                本隐私政策帮助您了解以下内容：
                <div class="mt-2">一、定义；</div>
                <div>二、我们如何收集和使用您的个人信息；</div>
                <div>三、我们如何存储和保护您的个人信息；</div>
                <div>四、我们如何共享、转让、公开披露您的个人信息；</div>
                <div>五、权限调用说明；</div>
                <div>六、第三方SDK调用说明；</div>
                <div>七、本政策如何更新；</div>
                <div>八、如何联系我们；</div>
              </div>
              <div class="text-h6 mb-4">一、定义</div>
              <div class="text-muted" style="text-indent: 2em">
                <strong>我们：</strong>指{{people_name}}。
              </div>
              <div class="text-muted" style="text-indent: 2em">
                <strong>个人信息：</strong>指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
              </div>
              <div class="text-muted" style="text-indent: 2em">
                <strong>个人敏感信息：</strong>指一旦泄露或者非法使用，可能导致个人受到歧视或者人身、财产受到严重危害的个人信息，包括种族、民族、宗教信仰、个人生物特征、医疗健康、金融账户、个人行踪等信息（我们将在本隐私政策中对具体个人敏感信息以粗体进行显著标识）。
              </div>
              <div class="text-muted" style="text-indent: 2em">
                <strong>未成年人：</strong>指不满18周岁的自然人。
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                <strong>儿童：</strong>指不满14周岁的自然人。
              </div>
              <div class="text-h6 mb-4">二、我们如何收集和使用您的个人信息</div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                个人信息是指以电子或者其他方式记录的能够单独或者与其他信息，
                结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
                我们根据《中华人民共和国网络安全法》和《信息安全技术个人信息安全规范》（GB/T
                35273-2017）
                以及其它相关法律法规的要求，并严格遵循正当、合法、必要的原则，
                出于您使用我们提供的服务和/或产品等过程中而收集和使用您的个人信息，包括但不限于电话号码等。
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                为接受我们全面的产品服务，您应首先注册一个用户账号，我们将通过它记录相关的数据。您所提供的所有信息均来自于您本人在注册时提供的数据。您准备使用的账户名、密码、您本人的联系方式，
                我们可能通过发短信或者邮件的方式来验证您的身份是否有效。
              </div>
              <div class="text-h6 mb-4">三、我们如何存储和保护您的个人信息</div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                作为一般规则，我们仅在实现信息收集目的所需的时间内保留您的个人信息。
                我们会在对于管理与您之间的关系严格必要的时间内保留您的个人信息
                （例如，当您开立帐户，从我们的产品获取服务时）。
                出于遵守法律义务或为证明某项权利或合同满足适用的诉讼时效要求的目的，
                我们可能需要在上述期限到期后保留您存档的个人信息，并且无法按您的要求删除。当您的个人信息对于我们的法定义务或法定时效对应的目的或档案不再必要时，
                我们确保将其完全删除或匿名化。
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                值得一提的是，为了加强对隐私数据的保护，我们在收集时就已对其进行了脱敏处理，
                即使在我们自己的数据库中，也不会储存具有关联性的、明文的隐私数据。
              </div>
              <div class="text-h6 mb-4">四、我们如何共享、转让、公开披露您的个人信息</div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                在管理我们的日常业务活动所需要时，为追求合法利益以更好地服务客户，
                我们将合规且恰当的使用您的个人信息。出于对业务和各个方面的综合考虑，我们仅自身使用这些数据，不与任何第三方分享。
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
                在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。
                我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                在以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
                <div class="mt-2">1、与国家安全、国防安全直接相关的；</div>
                <div>2、与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>
                <div>
                  3、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
                </div>
                <div>4、您自行向社会公众公开的个人信息；</div>
                <div>
                  5、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
                </div>
                <div>6、根据个人信息主体要求签订和履行合同所必需的；</div>
                <div>
                  7、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
                </div>
                <div>8、法律法规规定的其他情形。</div>
              </div>
              <br>
              <br>
              <h3>五、权限调用及应用相关说明</h3>
              <ul style="padding:0 0 0 20px">
                <li>
                  <strong>相机权限</strong>：拍照功能在经过您的允许后，扫一扫会使用到相机权限。
                </li>
                <li>
                  <strong>相册权限</strong>：上传图片功能，在经过您的允许后，保存图片时会使用到相册权限。
                </li>
                <li>
                  <strong>蓝牙权限</strong>：为了连接蓝牙设备，我们在经过您的允许后，会使用到蓝牙权限。
                </li>
                <li>
                  <strong>应用检测更新说明</strong>：为了提供给您最新的版本应用，我们会在后台检测是否有新版本，如有新版本会提醒更新。
                </li>

              </ul>
              <br>
              <h3>六、第三方SDK调用说明</h3>

              <h4>合作目的：为 APP 用户提供信息推送服务</h4>

              <h4>处理个人信息类型及用途：</h4>
              <ul style="padding:0 0 0 20px">
                <li>
                  <strong>设备标识符（包括Android
                    ID、GAID、OAID、UAID、IDFA、AAID）</strong>：必要个人信息，用于推送服务基本业务功能场景中生成脱敏的终端用户设备唯一性标识，保证服务在不同设备上的兼容性和准确识别，同时了解推送信息送达的情况。
                </li>
                <li>
                  <strong>设备硬件信息（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称、设备存储空间）</strong>：必要个人信息，用于推送服务的兼容性和优化。
                </li>
                <li>
                  <strong>操作系统信息（包括操作系统版本、系统名称、系统语言）</strong>：必要个人信息，用于推送服务的适配和优化。
                </li>
                <li>
                  <strong>网络信息（包括网络类型、运营商信息、IP地址、WIFI状态信息）</strong>：必要个人信息，用于推送服务的基本业务功能。
                  <ul>
                    <li>
                      <strong>可选个人信息（包括SSID、BSSID、WIFI列表信息、基站信息）</strong>：用于推送服务基本业务功能场景中判定模糊位置信息，选择就近推送服务节点提供推送服务，提升推送触达率。
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>推送信息日志</strong>：必要个人信息，用于记录推送服务的基本业务功能情况。
                </li>
                <li>
                  <strong>设备标识符（包括IMEI、MAC、IMSI）</strong>：可选个人信息，用于提升唯一设备标识的准确性，进而提升推送的精确度和触达率。
                </li>
                <li>
                  <strong>位置相关信息（地理围栏、用户分群推送扩展功能所必要个人信息）</strong>：用于提供线下场景的精细化推送，根据位置信息推荐更符合您需要的推送内容。
                </li>
                <li>
                  <strong>软件列表信息（包括软件列表及软件运行列表信息）</strong>：用户分群、应用自启动、链路调节器扩展功能所必要个人信息，有助于帮助您洞察您终端用户的兴趣偏好，帮助您为用户提供更合适的推送内容，同时优化SDK长连接稳定性，提升推送送达率及应用活跃度及通过合并链路，达到为用户省电省流量的目的。
                </li>
              </ul>

              <h4>数据处理方式：</h4>
              <p>通过去标识化、加密传输及其他安全方式。</p>

              <h4>极光隐私权政策链接：</h4>
              <p><a href="https://www.jiguang.cn/privacy.html" target="_blank">《AURORA 极光隐私政策》</a> 链接
                https://www.jiguang.cn/privacy.html</p>

              <h4>官网链接：</h4>
              <p><a href="https://www.jiguang.cn/" target="_blank">https://www.jiguang.cn/</a></p>

              <br>


              <div class="text-h6 mb-4">七、本政策如何更新</div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                我们的隐私政策可能变更。
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                未经您明确同意，我们不会削减您在本政策项下应享有的权利。我们会在本页面上发布对本政策所作的任何变更。
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                对于重大变更，我们还会提供更为显著的通知（比如官方公告、推送通知、发送短信或者电子邮件），并在本政策更新后您首次登陆时再次获取您的明示同意。若您在本政策更新且接到我们的通知后，点击同意或下一步，这表示您已充分阅读、理解并接受修订后的本政策。
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                本政策所指的重大变更包括但不限于：
                <div class="mt-2">
                  1、我们的服务模式发生重大变化，比如处理个人信息的类型、目的和方式等；
                </div>
                <div>
                  2、我们在所有权结构、组织架构等方面发生重大变化，比如业务调整、并购、破产等引起的所有者变更等；
                </div>
                <div>3、个人信息共享、转让或者公开披露的主要对象发生变化；</div>
                <div>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</div>
                <div>
                  5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
                </div>
                <div>6、个人信息安全影响评估报告表明存在高风险时。</div>
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                我们还会将本政策的旧版本存档，供您查阅。
              </div>

              <div class="text-h6 mb-4">八、如何联系我们</div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                1.如果您对本政策有任何疑问、意见或建议，可通过以下方式与我们联系：
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                <div>（1）发送电子邮件至：{{ email }}</div>
                <div>
                  （2）联系地址：湖南省长沙市岳麓区望城坡街道枫林三路49号换乘大楼101一楼南侧105，联系人：前台
                </div>
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                我们的客服部门将会同个人信息保护部门30天内进行回复，并协助解决您的问题。
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                2.如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方式：向{{people_name}}所在地人民法院提起诉讼，或向网信、工商、公安等监管部门进行投诉或举报。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">（完）</div>
            </div>
          </v-container>
        </v-content>
      </v-app>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "大象系统",
      email: 'admin@daxiangsys.com',
      people_name:"大象系统"
    };
  },
  mounted() {
    var query = this.$route.query;
    if (query.name) {
      this.name = query.name;
    } else {
      this.name = "大象系统";
    }
  },
};
</script>

<style scoped>
.content {
  padding: 20px;
}
</style>
